/* global window */
export default window;
